import React from 'react';
import './terms-conditions.css'; 

const TermsRatesComponent = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-4">
        <h1>Terms & Rates</h1>
        <p className="text-muted">Transparency in lending. No hidden charges, no surprises.</p>
      </header>

      <section className="tc-content mb-3">
        <h2>How is APR determined?</h2>
        <p>
          The Annual Percentage Rate (APR) is the total cost of borrowing expressed as a yearly 
          percentage. At <b>Singh Finlease Private Limited</b>, the APR is determined by 
          combining the nominal interest rate, processing fees, and other associated costs. 
          While traditional banks use complex credit scoring, we maintain a transparent and 
          fixed rate structure for our short-term credit products.
        </p>

        <h2>Working of Our Rates & Fees</h2>
        <p>
          Our lending model operates on a daily interest rate of <b>1% (30% Monthly)</b>. 
          The APR helps you compare our loan offers with other financial institutions by 
          reflecting the actual annual cost. Our APR typically ranges from <b>120% to 365%</b>, 
          depending on the loan tenure and the specific fee structure applied to the principal.
        </p>

        <div className="alert alert-light border">
          <strong>Note:</strong> Loan tenures range from 30 to 90 days. Processing fees are 
          calculated based on the sanctioned loan amount and are deducted upfront.
        </div>

        {/* Repayment Example Table */}
        <h3 className="mt-4">Representative Loan Examples</h3>
        <div className="table-responsive mt-3">
          <table className="table table-bordered text-center align-middle">
            <thead className="table-dark">
              <tr>
                <th>Loan Amount</th>
                <th>Monthly Interest</th>
                <th>APR (Annual)</th>
                <th>Tenure</th>
                <th>Processing Fee (Incl. GST)</th>
                <th>Disbursed Amount</th>
                <th>Total Interest</th>
                <th>Total Repayment</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>₹10,000</b></td>
                <td>30%</td>
                <td>365%</td>
                <td>30 Days</td>
                <td>₹1,180</td>
                <td>₹8,820</td>
                <td>₹3,000</td>
                <td><b>₹13,000</b></td>
              </tr>
              <tr>
                <td><b>₹25,000</b></td>
                <td>30%</td>
                <td>365%</td>
                <td>30 Days</td>
                <td>₹2,950</td>
                <td>₹22,050</td>
                <td>₹7,500</td>
                <td><b>₹32,500</b></td>
              </tr>
              <tr>
                <td><b>₹50,000</b></td>
                <td>30%</td>
                <td>365%</td>
                <td>30 Days</td>
                <td>₹5,900</td>
                <td>₹44,100</td>
                <td>₹15,000</td>
                <td><b>₹65,000</b></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-4">
          <h4>Key Financial Terms:</h4>
          <ul>
            <li><b>Daily Interest:</b> 1% of the principal amount.</li>
            <li><b>Monthly Interest:</b> 30% of the principal amount.</li>
            <li><b>Processing Fees:</b> Usually ranges from 8% to 15% (subject to 18% GST).</li>
            <li><b>Default Charges:</b> Late payments attract a daily penalty fee in addition to the standard interest.</li>
            <li><b>Prepayment:</b> We allow early repayment without any additional penalty or "foreclosure" fees.</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default TermsRatesComponent;